import React from 'react';
import styles from './MenuItem.module.css';

const MenuItem = ({ name, icon, active, onClick, closeMenu }) => {
  const handleClick = () => {
    closeMenu();
    onClick();
  };

  return (
    <li className={`${styles.menuItem} ${active ? styles.active : ''}`}>
      <button
        className={`naked-button ${styles.button}`}
        type="button"
        onClick={handleClick}
      >
        {icon && <i className={icon} />}
        {name}
      </button>
    </li>
  );
};

export default MenuItem;
